import MapModal from 'components/desktop/detail/main-section/main-section-left/map-section/map-modal';
import {
  IconBuilding,
  IconHouseDoor,
  IconLocationFill,
  IconPercentage,
  IconTag,
  IconVectorSquareClose,
} from 'components/icons';
import ModalWrapper from 'components/shared/modal-wrapper';
import { SITE_MAP } from 'globalConstants';
import { useModal } from 'hooks';
import { capitalize, filter, isNil, map, toNumber } from 'lodash';
import { DetailProjectPageContext } from 'pages/du-an/[chi-tiet-du-an]';
import { useContext } from 'react';
import { convertNumberToVietnameseCurrencyShortString } from '../../../../utils';
import Breadcrumb from '../../shared/breadcrumb';

const Overview = () => {
  const { project } = useContext(DetailProjectPageContext).pageData ?? {};
  const {
    totalBlock,
    totalProduct,
    expectedPrice,
    commission,
    project: projectDetail,
  } = project ?? {};
  const {
    projectName,
    fullAddress,
    projectArea,
    investorName,
    map: projectMap,
  } = projectDetail ?? {};
  const { area } = projectArea ?? {};
  const { showing: showingMapModal, toggle: toggleMapModal } = useModal();
  const breadcrumbs = [{ name: 'Dự án', slug: SITE_MAP.PROJECT.INDEX }, { name: projectName }];

  return (
    <section className='container mx-auto flex min-w-[1052px] flex-col space-x-[24px] px-[54px] screen-1140:px-[98px] xl:px-[48px] screen-1366:px-[83px]'>
      <div className='rounded-[16px] bg-paper p-[24px] shadow-7'>
        <div className='space-y-[16px]'>
          <Breadcrumb breadcrumbs={breadcrumbs} />
          {projectName && (
            <h1 className='text-[24px] font-[600] capitalize leading-[30px]'>{projectName}</h1>
          )}
        </div>
        {fullAddress && (
          <div className='flex items-start justify-between space-x-[6px] border-b-[1px] border-stroke py-[16px]'>
            <div className='flex items-center space-x-[6px]'>
              <IconLocationFill className='mr-[3px] min-h-[18px] min-w-[18px] text-text2' />
              <span>{fullAddress}</span>
            </div>
            <button className='whitespace-nowrap font-[600] text-primary' onClick={toggleMapModal}>
              Xem bản đồ
            </button>
            <ModalWrapper showing={showingMapModal}>
              <MapModal map={projectMap} onClose={toggleMapModal} />
            </ModalWrapper>
          </div>
        )}
        <div className='flex items-center space-x-[8px] border-b-[1px] border-stroke py-[16px]'>
          <IconTag className='h-[20px] w-[20px] text-green' />
          <span>Giá bán</span>
          <span className='text-[24px] font-[600] leading-[30px] text-alert'>
            {isNil(expectedPrice)
              ? 'Thương lượng'
              : `${convertNumberToVietnameseCurrencyShortString(toNumber(expectedPrice.from))} ${
                  '- ' +
                  convertNumberToVietnameseCurrencyShortString(toNumber(expectedPrice.to)) +
                  ' '
                }VND/m\u00B2`}
          </span>
        </div>
        {commission && (
          <div className='flex items-center space-x-[10px] border-b-[1px] border-stroke py-[16px]'>
            <IconPercentage className='h-[20px] w-[20px] text-orange' />
            <span>Hoa hồng được hưởng</span>
            <span className='text-[16px] font-[600] leading-[20px]'>{commission}</span>
          </div>
        )}
        <div className='flex min-h-[18px] space-x-[24px] border-b-[1px] border-stroke py-[16px]'>
          {map(
            filter(
              [
                {
                  icon: <IconVectorSquareClose className='h-[18px] w-[18px]' />,
                  content: area,
                  suffix: 'm\u00B2',
                },
                {
                  icon: <IconBuilding className='h-[18px] w-[18px]' />,
                  content: totalBlock,
                  suffix: 'block',
                },
                {
                  icon: <IconHouseDoor className='h-[18px] w-[18px]' />,
                  content: totalProduct,
                  suffix: 'căn',
                },
              ],
              (item) => Boolean(item.content),
            ),
            (detail, detailIndex) => (
              <div key={detailIndex} className='flex items-center space-x-[8px]'>
                {detail.icon}
                <span className='truncate'>
                  {detail.content?.toLocaleString()} {detail.suffix}
                </span>
              </div>
            ),
          )}
        </div>
        {investorName && (
          <div className='mt-[16px] flex'>
            <span>
              Chủ đầu tư: <span className='font-[600]'>{capitalize(investorName)}</span>
            </span>
          </div>
        )}
      </div>
    </section>
  );
};

export default Overview;
